import { State, Action } from 'src/types'
import {
  SET_SELECTED_PARTS,
  SET_ALL_LEATHER_COLOR,
  SET_DOMINANT_ARM,
  SET_WEB_PARTS,
  SET_LEATHER_COLOR,
  SET_EDGE_COLOR,
  SET_LININGS,
  SET_HAMIDASHI,
  SET_FINGER_GUARD_TYPE,
  SET_LACE_COLOR,
  SET_LIST_LINING_MATERIAL,
  SET_STITCH_COLOR,
  SET_EMBROIDERIES,
  ADD_EMBROIDERY,
  REMOVE_EMBROIDERY,
  SET_MATERIAL_PACK,
  SET_WEB_COLOR,
  SET_THUMB_HOOK,
  SET_LITTLE_HOOK,
  SET_INDEX_COVER_COLOR,
  SET_PERSONAL,
  SET_LIST_BELT_COLOR,
  SET_MOUTON_COLOR,
  SET_DxM_LABEL,
  SET_BASE_MODEL,
  SET_LOOP_OF_RING_FINGER,
  SET_SPECIFY_LABEL,
  SET_TANNER,
  SET_DxM_LABEL_CORE,
  SET_BACK_STYLE,
  SET_CATCH_FACE_TARGET_COLOR,
  SET_FINGER_STAND_COLOR,
  SET_THUMB_COLOR,
  SET_LITTLE_COLOR,
  SET_INDEX_MIDDLE_RIGHT_COLOR,
  SET_MIDDLE_LEFT_RING_COLOR,
  SET_FIGURE_PANEL_NUMBER
} from 'src/features/brands/dxm/constants/actionType'
import { colorInitialState, initialEmbroideryState, initialStateCatcherMitt } from 'src/features/brands/dxm/reducer'
import { baseInitialState, initialPersonalState, unselectedColorState, unselectedState } from 'src/features/brands/reducer'

export const initialCatcherState: State = {
  ...initialStateCatcherMitt,
  ...baseInitialState,
  tanner: unselectedState,
  materialPack: unselectedState,
  webParts: unselectedColorState,
  loopOfRingFinger: unselectedColorState,
  loopOfRingFingerColor: unselectedColorState,
  hamidashiCut: unselectedState,
  ...colorInitialState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1
}

export const catcherReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case SET_SELECTED_PARTS:
      return { ...state, parts: action.parts }
    case SET_ALL_LEATHER_COLOR:
      return {
        ...state,
        all: action.all,
        catchFace: action.all,
        web: action.all,
        thumbHook: action.all,
        littleHook: action.all,
        edge: action.all,
        indexCover: action.all,
        thumb: action.all,
        indexMiddleRight: action.all,
        middleLeftRing: action.all, // 中指左、薬指、小指
        listBelt: action.all,
        linings: action.all,
        little: action.all,
        loopOfRingFingerColor: action.all,
        catchFaceTarget: action.all,
        fingerStand: action.all
      }
    case SET_BASE_MODEL:
      return { ...state, baseModel: action.baseModel, tanner: { label: 'DTS - Leather', value: 'dtsLeather' } }
    case SET_TANNER:
      return { ...state, tanner: action.tanner }
    case SET_BACK_STYLE:
      return { ...state, backStyle: action.backStyle }
    case SET_DOMINANT_ARM:
      return { ...state, dominantArm: action.dominantArm }
    case SET_MATERIAL_PACK:
      return { ...state, materialPack: action.materialPack }
    case SET_FINGER_GUARD_TYPE:
      return { ...state, fingerGuardType: action.fingerGuardType, figurePanelNum: 1 }
    case SET_LOOP_OF_RING_FINGER:
      return { ...state, loopOfRingFinger: action.loopOfRingFinger }
    case SET_WEB_PARTS:
      return { ...state, webParts: action.webParts }
    case SET_SPECIFY_LABEL:
      const isChange = state.specifyLabel.value !== action.specifyLabel.value
      return {
        ...state,
        specifyLabel: action.specifyLabel,
        dxmLabel: isChange ? unselectedState : state.dxmLabel,
        dxmLabelCore: isChange ? unselectedState : state.dxmLabelCore,
        figurePanelNum: 1
      }
    case SET_DxM_LABEL:
      return { ...state, dxmLabel: action.dxmLabel, figurePanelNum: 1 }
    case SET_DxM_LABEL_CORE:
      return { ...state, dxmLabelCore: action.dxmLabelCore, figurePanelNum: 1 }
    case SET_LEATHER_COLOR:
      return { ...state, catchFace: action.catchFace }
    case SET_EDGE_COLOR:
      return { ...state, edge: action.edge }
    case SET_WEB_COLOR:
      return { ...state, web: action.web }
    case SET_MOUTON_COLOR:
      return { ...state, mouton: action.mouton }
    case SET_THUMB_COLOR:
      return { ...state, thumb: action.thumb }
    case SET_INDEX_MIDDLE_RIGHT_COLOR:
      return { ...state, indexMiddleRight: action.indexMiddleRight }
    case SET_MIDDLE_LEFT_RING_COLOR:
      return { ...state, middleLeftRing: action.middleLeftRing }
    case SET_LITTLE_COLOR:
      return { ...state, little: action.little }
    case SET_LIST_BELT_COLOR:
      return { ...state, listBelt: action.listBelt }
    case SET_LININGS:
      return { ...state, linings: action.linings, figurePanelNum: 1 }
    case SET_HAMIDASHI:
      return { ...state, hamidashi: action.hamidashi }
    case SET_LACE_COLOR:
      return { ...state, lace: action.lace }
    case SET_LIST_LINING_MATERIAL:
      return { ...state, listLiningsMaterial: action.listLiningsMaterial }
    case SET_STITCH_COLOR:
      return { ...state, stitch: action.stitch }
    case SET_CATCH_FACE_TARGET_COLOR:
      return { ...state, catchFaceTarget: action.catchFaceTarget }
    case SET_FINGER_STAND_COLOR:
      return { ...state, fingerStand: action.fingerStand }
    case SET_EMBROIDERIES:
      return { ...state, embroideries: action.embroideries, figurePanelNum: 1 }
    case ADD_EMBROIDERY: // incrementの方が合っている気がする
      return { ...state, embroideries: action.embroideries }
    case REMOVE_EMBROIDERY: // decrementの方が合っている気がする
      return { ...state, embroideries: action.embroideries }
    case SET_THUMB_HOOK:
      return { ...state, thumbHook: action.thumbHook, figurePanelNum: 1 }
    case SET_LITTLE_HOOK:
      return { ...state, littleHook: action.littleHook, figurePanelNum: 1 }
    case SET_INDEX_COVER_COLOR:
      return { ...state, indexCover: action.indexCover, figurePanelNum: 1 }
    case SET_PERSONAL:
      return { ...state, personal: action.personal }
    case SET_FIGURE_PANEL_NUMBER:
      return { ...state, figurePanelNum: action.figurePanelNum }
    default:
      return state
  }
}
